module.exports = __webpack_public_path__ + "img/王娜.b6a44507.jpg";